import { TvDAO } from "../DAO/Tv.dao";
import { clone } from "lodash";
import { TvItem } from "../Model/TvItem.model";
import { TvModel } from "../Model/Tv.model";
import { useRoot } from "../../../Contexts/Root.context";
import { HostModel } from "../../URLConfig/Model/Host.model";
import { TvDataModel } from "../Model/TvData.model";
import { URLConfigDAO } from "../../URLConfig/DAO/URLConfig.dao";
import { connect, Socket } from "socket.io-client";
import { useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { IError, ILoading, Timeout, useTimeoutCleaner } from "xa-generics";
import ErrorView from "../../Error/View/Error.view";
import TvView from "../View/Tv.view";

export interface ITVProps extends RouteComponentProps<{ id: string }> {}

const TV: React.FC<ITVProps> = (props) => {
    const { audio } = useRoot();
    const [error, setError] = useState<IError>(null);
    const [loading, setLoading] = useState<ILoading>(true);
    const [host, setHost] = useState<HostModel | null>(null);
    const [list, setList] = useState<TvModel>(new TvModel());
    const [socket, setSocket] = useState<null | Socket>(null);
    const [tv, setTv] = useState<TvDataModel>(new TvDataModel());
    const [newDoneItems, setNewDoneItems] = useState<string[]>([]);

    const id = props.match.params.id;

    const diff = (prevArray: TvItem[], newArray: TvItem[]): string[] => {
        let res: string[] = [];

        let prevArrayStrings: string[] = [];
        for (let i = 0; i < prevArray.length; i++) prevArrayStrings.push(prevArray[i].value);

        let newArrayStrings: string[] = [];
        for (let i = 0; i < newArray.length; i++) newArrayStrings.push(newArray[i].value);

        for (let i = 0; i < newArray.length; i++) {
            if (prevArrayStrings.indexOf(newArrayStrings[i]) === -1) res.push(newArrayStrings[i]);
        }

        return res.reverse();
    };

    const showNewDoneItems = (newItems: string[]): void => {
        if (newItems.length === 0) return;
        setNewDoneItems(newItems);
        if (tv.enable_sound) {
            audio.currentTime = 0;
            audio.muted = false;
            audio.play();
        }

        Timeout.bindTimeout(() => setNewDoneItems([]), 3000, "showNewDoneItems");
    };

    const onLoad = (): void => {
        setLoading(
            TvDAO.load(id)
                .then((tvList) => {
                    setList((current) => {
                        const doneDiff = diff(list.done, tvList.done);
                        showNewDoneItems(doneDiff);
                        const state = clone(current);
                        state.in_progress = tvList.in_progress;

                        for (let i = 0; i < doneDiff.length; i++)
                            state.done.unshift(new TvItem({ value: doneDiff[i] }));

                        state.done.splice(20);

                        return state;
                    });
                })
                .catch((error: IError) => setError(error))
                .finally(() => setLoading(false))
        );
    };

    useEffect(
        () => {
            if (socket) {
                onLoad();
                socket.on("TASK_KQ_RELOAD", onLoad);
            }

            return () => {
                if (socket) {
                    socket.removeListener("TASK_KQ_RELOAD", onLoad);
                }
            };
        },
        // eslint-disable-next-line
        [socket]
    );

    useEffect(() => {
        if (host && host.socket_url && tv.restaurant_id) {
            setSocket(
                connect(host.socket_url, {
                    path: "/POS",
                    autoConnect: true,
                    reconnectionDelay: 3000,
                    reconnectionAttempts: Infinity,
                    query: { restaurant_id: tv.restaurant_id }
                })
            );
        }
    }, [host, tv.restaurant_id]);

    useEffect(() => {
        if (tv.id) {
            URLConfigDAO.loadServer(tv.restaurant_id)
                .then((data) => setHost(data))
                .catch((e) => console.error(e));
        }
    }, [tv.id, tv.restaurant_id]);

    useEffect(() => {
        if (!id) return;

        setLoading(
            TvDAO.loadTV(id)
                .then((tv) => setTv(tv))
                .catch((error: any) => setError(error))
                .finally(() => setLoading(false))
        );
    }, [id]);

    useTimeoutCleaner();

    if (error) return <ErrorView error={error} />;

    if (newDoneItems.length > 0)
        return (
            <div className="new-done-orders">
                <div className="top-container">
                    <div className="top-container__text">ELKÉSZÜLT</div>
                </div>
                {newDoneItems.map((item) => (
                    <div key={`${item}-new-done-item`} className="text">
                        {item}
                    </div>
                ))}
            </div>
        );

    return <TvView list={list} loading={loading} tv={tv} />;
};

export default withRouter(TV);
